import WindowIpcRenderer from '@renderer/ipc/WindowIpc.renderer'
import GlobalLogger from '@shared/utils/logger/GlobalLogger'

/**
 * The gateway refused a turn because the account has no recorded 2.0
 * onboarding. Main owns the reaction (deliver a stamp this machine still owes,
 * or reopen the flow); the renderer only hands the verdict over.
 */
export function restartOnboarding(): void {
  void WindowIpcRenderer.onboardingRequiredByServer().catch((error) => {
    GlobalLogger.error(`could not hand the onboarding-required verdict to main: ${String(error)}`, {
      class: 'onboarding',
    })
  })
}
